/**
 * The service for managing state location.
 *  Contains all the methods needed for state location handling.
 */
var StateLocationService = /** @class */ (function () {
    /*@ngInject*/
    function StateLocationService($location, $state, stateHistoryService) {
        this.$location = $location;
        this.$state = $state;
        this.stateHistoryService = stateHistoryService;
        this.preventCall = [];
    }
    StateLocationService.prototype.locationChange = function () {
        var entry;
        var poppedValue = this.preventCall.pop();
        if (!_.isUndefined(poppedValue) && !_.isNull(poppedValue) && poppedValue == 'locationChange') {
            return;
        }
        if (this.$location.url() == "" || this.$location.url() == "/") {
            this.preventCall.push('stateChange');
            this.$state.go('login', null, { reload: true });
            return;
        }
        entry = this.stateHistoryService.get(this.$location.url());
        if (_.isNull(entry) || _.isUndefined(entry) || entry == '') {
            // if(this.$location.url() == '/login') {
            //     this.preventCall.push('stateChange');
            // }
            if (this._currentScreenDoesNotRequireLogin()) {
                return this.$location.url();
            }
            if (this._currentUrlIsInvalid()) {
                this.$state.go('login', null, { reload: true });
                return;
            }
            return;
        }
        this.preventCall.push('stateChange');
        return this.$state.go(entry.name, entry.params, {
            location: false
        });
    };
    StateLocationService.prototype._currentScreenDoesNotRequireLogin = function () {
        return this.$location.path() == '/login' || this.$location.path() == '/setpassword' || this.$location.path() == '/authenticateToken' || this.$location.path() == '/conference' || this.$location.path() == '/candidateConference' || this.$location.path() == '/candidateOutreach';
    };
    StateLocationService.prototype._currentUrlIsInvalid = function () {
        return this.$state.current.url == '^' && !this.$location.$$absUrl.includes('conference');
    };
    StateLocationService.prototype.stateChange = function () {
        var entry, url;
        var poppedValue = this.preventCall.pop();
        if (!_.isUndefined(poppedValue) && !_.isNull(poppedValue) && poppedValue == 'stateChange') {
            return;
        }
        entry = {
            name: this.$state.current.name,
            params: this.$state.params
        };
        if (this.$state.current.url == '/login' || this.$state.current.url == '/setpassword' || this.$state.current.url == '/authenticateToken?a&t&cid&comp' || this.$state.current.url == '/conference?c&j&jm&t&mode&sh&ws&m' || this.$state.current.url == '/candidateConference?c&j&jm&t&mode&sh&ws&m') {
            // if(this.$state.current.url == '/setpassword' || this.$state.current.url == '/authenticateToken?a&t' || this.$state.current.url.toLowerCase().includes('conference')) {
            return this.$location.url();
        }
        url = this.$state.current.url + "/" + (this.getGUIDForUniqueURL().substr(0, 8));
        this.stateHistoryService.set(url, entry);
        this.preventCall.push('locationChange');
        return this.$location.url(url);
    };
    StateLocationService.prototype.getGUIDForUniqueURL = function () {
        var s4;
        s4 = function () {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        };
        return "" + (s4()) + (s4()) + "-" + (s4()) + "-" + (s4()) + "-" + (s4()) + "-" + (s4()) + (s4()) + (s4());
    };
    return StateLocationService;
}());
export { StateLocationService };
//# sourceMappingURL=stateLocationService.js.map